<template>
<div>
	<p class="font-thin text-3xl mb-2">Generella inställningar</p>

	<div class="flex items-start pt-2 group cursor-pointer" @click="updateFontOutline()">
		<div class="flex items-center h-5 cursor-pointer">
			<span :class="{'bg-blue' : useFontOutline}" class="group-hover:shadow-outline bg-white border rounded h-5 w-5 my-auto flex justify-center items-center transition duration-150 ease-in-out">
				<svg class="w-3 h-3 text-white" viewBox="0 0 24 24" stroke-width="4" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
					<path stroke="none" d="M0 0h24v24H0z"/>
					<path d="M5 12l5 5l10 -10"/>
				</svg>
			</span>
		</div>
		<div class="ml-3 text-sm leading-5 select-none cursor-pointer">
			<label class="font-medium text-gray-900 transition duration-150 ease-in-out cursor-pointer group-hover:text-gray-500">Använd textkontur</label>
		</div>
	</div>
</div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {

	name: 'GeneralSettings',

	computed: {
		...mapGetters({
			useFontOutline: 'settings/useFontOutline',
		}),
	},

	methods: {
		updateSetting(params) {
			this.$store.dispatch('settings/UPDATE_SETTING', params)
		},

		updateFontOutline() {
			this.updateSetting({
				setting: 'useFontOutline',
				value: !this.useFontOutline
			})
		}
	}
}
</script>